export default {
    nav: {
        home: 'Accueil',
        products: 'Produits',
        solutions: 'Solutions',
        support: 'Assistance',
        aboutUs: 'À propos de nous',
        contact: 'Contactez-nous',
        software: 'Logiciel'
    },
    hero: {
        title: 'Kooyii Smart',
        desc1: 'Nous pouvons fournir des applications de maison intelligente personnalisées.',
        desc2: 'Si vous souhaitez une application à l\'image de votre marque, des serveurs privés...',
        desc3: 'Alors nous sommes votre meilleur choix.'
    },
    main1: {
        title: 'Page d\'accueil personnalisée',
        subtitle: 'L\'application Kooyii vous permet de choisir vos raccourcis selon vos habitudes pour contrôler facilement vos appareils.',
        desc1: 'Le Cloud synchronise automatiquement la date et l\'heure locales.',
        desc2: 'Ajoutez des caméras à l\'accueil pour visionner facilement les flux vidéo. Cliquez pour ajuster l\'angle via PTZ.',
        desc3: 'Ajoutez des serrures à l\'accueil pour les déverrouiller facilement à distance.',
        desc4: 'Le Cloud synchronise automatiquement la météo et la température locales.',
        desc5: 'Armement/désarmement par lots pour les centrales d\'alarme et les passerelles.',
        desc6: 'Ajoutez des interrupteurs à l\'accueil pour allumer/éteindre rapidement les lumières.',
        desc7: 'Ajoutez des rideaux à l\'accueil pour contrôler rapidement leur ouverture/fermeture/pause.'
    },
    main2: {
        title: 'Gestion des appareils',
        subtitle: 'L\'application Kooyii affiche les appareils par zones pour vous aider à les trouver et les contrôler plus rapidement.',
        desc1: 'Sélectionnez une zone pour afficher les appareils de cette zone.',
        desc2: 'Cliquez pour contrôler à distance les rideaux et configurer leur rotation.',
        desc3: 'Cliquez pour régler à distance l\'allumage, la luminosité et la température de couleur des lumières.',
        desc4: 'Cliquez pour ajouter/contrôler des téléviseurs, des climatiseurs, etc.',
        desc5: 'Cliquez pour supprimer des appareils ou les affecter à une zone spécifique.',
        desc6: 'Cliquez pour allumer/éteindre les lumières à distance, régler des minuteries, etc.',
        desc7: 'Cliquez pour armer/désarmer à distance, ajouter des sous-appareils, configurer des fonds d\'écran, etc.',
        desc8: 'Cliquez pour utiliser les passerelles VRF pour la climatisation centrale.'
    },
    main3: {
        title: 'Scènes intelligentes et automatisation',
        subtitle: 'Configurez des scènes et des automatisations pour lier intelligemment tous les appareils de la maison.',
        desc1: 'Cliquez pour basculer entre scènes et automatisations.',
        desc2: 'Cliquez pour entrer dans la page d\'édition et modifier ou supprimer des commandes d\'action.',
        desc3: 'Cliquez pour ajouter une scène, sélectionnez l\'appareil et l\'action ; l\'effet est immédiat.',
        desc4: 'Cliquez pour exécuter des scènes prédéfinies d\'un simple toucher.'
    },
    about: {
        title: 'À propos de nous',
        desc1: 'Kooyii est une application mobile complète développée indépendamment par Shenzhen Golden Security Technology Co., Ltd., intégrant la domotique et les alarmes de sécurité. Via l\'application, les utilisateurs peuvent ajouter et contrôler des appareils, configurer des scènes d\'automatisation et recevoir des alertes à tout moment et en tout lieu.',
        desc2: 'L\'application prend en charge le contrôle d\'appareils intelligents via plusieurs protocoles, couvrant divers scénarios tels que la maison intelligente, les alarmes de sécurité, les hôtels intelligents et l\'automatisation des bâtiments.',
        desc3: 'En tant qu\'entreprise de haute technologie intégrant la R&D, la production et les ventes, nous fournissons à nos clients des services tels que le développement de matériel, la personnalisation de logiciels et le déploiement privé pour répondre à des besoins diversifiés.'
    },
    protocol: {
        title: 'Protocoles pris en charge',
        cards: {
            zigbee: 'Zigbee 3.0 est une norme de communication sans fil unifiée introduite par la Connectivity Standards Alliance (CSA), permettant une interopérabilité fluide entre les marques et des réseaux maillés à faible consommation en intégrant protocoles d\'applications fragmentés.',
            wifi: 'Le Wi-Fi est une technologie de réseau sans fil mondialement reconnue qui transmet des données via des ondes radio, permettant aux appareils de se connecter aux réseaux sans câbles physiques.',
            rf433: 'Le 433 MHz est une bande radio basse fréquence couramment utilisée pour les appareils à courte portée et à faible consommation tels que les systèmes d\'alarme de sécurité et les interrupteurs intelligents.',
            modbus: 'Modbus est un protocole de communication série largement utilisé dans l\'automatisation industrielle, prenant en charge la communication maître-esclave et l\'échange de données.',
            knx: 'KNX est une technologie de bus standard européenne largement utilisée dans les systèmes domotiques pour les bâtiments intelligents.',
            bluetooth: 'Le Bluetooth est une technologie sans fil pour la communication entre appareils, largement utilisée dans les hôtels intelligents, la domotique et d\'autres domaines.'
        }
    },
    features: {
        title: 'Ce que vous pouvez faire avec cette application',
        remoteControl: {
            title: 'Contrôle à Distance',
            desc: 'Contrôlez les appareils intelligents à distance.'
        },
        armDisarm: {
            title: 'Armer/Désarmer',
            desc: 'Configurez les modes d\'armement/désarmement pour la centrale d\'alarme.'
        },
        alarmPush: {
            title: 'Recevoir des Alarmes',
            desc: 'Recevez des notifications instantanées sur votre téléphone en cas d\'alerte.'
        },
        scenes: {
            title: 'Scènes Intelligentes',
            desc: 'Configurez une exécution en un clic en fonction de vos scénarios.'
        },
        automation: {
            title: 'Automatisation',
            desc: 'Permet à vos appareils d\'exécuter automatiquement des commandes lorsque des conditions sont remplies.'
        },
        familyShare: {
            title: 'Partage Familial',
            desc: 'Invitez votre famille à gérer les appareils ensemble.'
        }
    },
    services: {
        title: 'Scénarios d\'application',
        features: {
            smartHome: {
                title: 'Maison Intelligente',
                desc: 'Brisez les limites des maisons traditionnelles pour créer un espace de vie intelligent pour tous les scénarios. Prenant en charge plusieurs protocoles tels que Zigbee et Wi-Fi, il permet l\'interconnectivité des appareils et le changement de scènes en toute fluidité. Débloquez un style de vie hautement efficace et pratique avec des opérations minimalistes, apportant la chaleur de la technologie à votre quotidien.'
            },
            security: {
                title: 'Sécurité Intelligente',
                desc: 'Une centrale d\'alarme associée à une plateforme de surveillance professionnelle pour construire un système de sécurité intégré. En tant que cœur du système, la centrale se connecte à divers détecteurs (infrarouges, fumée, boutons d\'urgence) via le protocole 433 MHz, permettant des alertes en temps réel pour les intrusions, les incendies et les urgences.'
            },
            hotel: {
                title: 'Hôtel Intelligent',
                desc: 'Centrée sur l\'IoT et associée à une plateforme de gestion des équipements hôteliers, cette solution connecte les chambres intelligentes, les opérations de la réception et les services en chambre, offrant une double valeur aux clients ainsi qu\'à la direction de l\'hôtel.'
            },
            building: {
                title: 'Automatisation de Bâtiments',
                desc: 'Basé sur RTU et configuré via un back-office de gestion, il prend en charge l\'intégration des appareils Modbus pour réaliser facilement une surveillance centralisée, un contrôle intelligent et la gestion énergétique des équipements du bâtiment, transformant ainsi les bâtiments traditionnels en bâtiments intelligents.'
            }
        }
    },
    software: {
        title: 'Logiciels et Plateformes',
        steps: {
            cms: { title: 'Centre de Télésurveillance', desc: 'Cliquez pour visiter' },
            kooyii: { title: 'Kooyii', desc: 'Survolez pour scanner et télécharger' },
            elderly: { title: 'Assistance aux Personnes Âgées', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            hotel: { title: 'Hôtel Intelligent', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            building: { title: 'Automatisation de Bâtiments', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            more: { title: 'Plus de Scénarios', desc: 'Veuillez contacter nos ventes pour des conseils professionnels.' }
        }
    },
    solutions: {
        services: {
            title: 'Nos Services',
            features: {
                hardware: {
                    title: 'Personnalisation Matérielle',
                    desc: 'Services exclusifs de conception et de fabrication de bout en bout, des cartes PCBA centrales à l\'esthétique complète de l\'appareil. Couvre la conception des circuits, la sélection des composants, le routage PCB, le débogage fonctionnel, les moules de boîtier, les matériaux et la protection structurelle.'
                },
                software: {
                    title: 'Personnalisation Logicielle',
                    desc: 'Développement d\'applications sur mesure et de systèmes web en fonction de vos besoins commerciaux réels, incluant les applications mobiles (iOS/Android), les pages web pour PC et la gestion back-office. Fournit une solution numérique hautement efficace adaptée à votre modèle opérationnel.'
                },
                server: {
                    title: 'Déploiement Privé',
                    desc: 'Déployez des systèmes, des plateformes ou des applications entièrement sur vos propres serveurs ou environnements intranet désignés. Les données et les services fonctionnent de manière totalement indépendante, permettant un contrôle autonome total.'
                }
            }
        },
        whyUs: {
            title: 'Pourquoi Nous Choisir ?',
            benefits: {
                oneStop: {
                    title: 'Service Tout-en-Un',
                    desc: 'Nos solutions couvrent à la fois les logiciels et le matériel avec un alignement complet et unifié, éliminant la coordination entre plusieurs parties, raccourcissant les cycles de développement et réduisant les coûts de communication.'
                },
                custom: {
                    title: 'Personnalisation Poussée',
                    desc: 'Les fonctionnalités logicielles sont précisément adaptées aux performances matérielles, évitant les problèmes de compatibilité et garantissant un fonctionnement global plus fluide avec des taux de panne plus faibles.'
                },
                expandable: {
                    title: 'Haute Évolutivité',
                    desc: 'Nos services réservent des interfaces d\'extension, facilitant la mise à niveau et l\'expansion des fonctionnalités par les clients en fonction de leurs besoins futurs.'
                },
                deployment: {
                    title: 'Déploiement Flexible',
                    desc: 'Qu\'il s\'agisse d\'un déploiement privé localisé ou d\'un déploiement sur cloud public, nous fournissons des solutions flexibles pour répondre à vos besoins.'
                }
            }
        },
        cta: {
            title: 'Prêt à améliorer votre style de vie ?',
            desc: 'Parlez dès aujourd\'hui à nos experts en maisons intelligentes et laissez-nous concevoir l\'écosystème parfait pour vous.',
            button: 'Contacter les Ventes'
        }
    },
    product: {
        nav: {
            panel: 'Panneaux de Contrôle',
            hub: 'Passerelles Intelligentes',
            switch: 'Interrupteurs Intelligents',
            curtain: 'Rideaux Intelligents',
            sensor: 'Capteurs',
            lighting: 'Éclairage Intelligent',
            security: 'Sécurité Intelligente',
            doorlock: 'Serrures Intelligentes'
        },
        sub: {
            '4inch': '4 Pouces',
            '5inch': '5 Pouces',
            '6inch': '6 Pouces',
            '7inch': '7 Pouces',
            '8inch': '8 Pouces',
            '10inch': '10 Pouces',
            '1gang': '1 Voie',
            '2gang': '2 Voies',
            '3gang': '3 Voies',
            '4gang': '4 Voies',
            'wireless': 'Sans fil',
            'wired': 'Filaire',
            'openclose': 'Moteur de Rideau',
            'roller': 'Store Enrouleur',
            'downlight': 'Spots et Downlights',
            'magnetic': 'Éclairage Magnétique',
            'strip': 'Bandeaux LED',
            'alarm': 'Centrale d\'Alarme',
            'door': 'Capteur d\'Ouverture',
            'smoke': 'Détecteur de Fumée',
            'infrared': 'Détecteur Infrarouge',
            'radar': 'Radar de Présence Humaine',
            'water': 'Détecteur de Fuite d\'Eau',
            'temp': 'Capteur Temp. & Humidité',
            'indoorCam': 'Caméra Intérieure',
            'outdoorCam': 'Caméra Extérieure',
            'password': 'Serrure à Code',
            'fingerprint': 'Serrure à Empreinte',
            'face': 'Serrure Faciale'
        },
        common: {
            learnMore: 'En savoir plus',
            addToCart: 'Ajouter au panier',
            buyNow: 'Acheter maintenant',
            emptyProduct: 'Aucun produit associé pour le moment. Restez à l\'écoute...'
        },
        cart: {
            titleList: 'Liste de Demandes',
            titleForm: 'Informations de Contact',
            empty: 'Votre liste est vide, ajoutez des produits !',
            delete: 'Supprimer',
            totalItems: 'Total de {count} produits sélectionnés',
            nextStep: 'Étape Suivante : Remplir les Infos',
            submit: 'Soumettre la Demande'
        },
        form: {
            name: 'Comment devons-nous vous appeler ?',
            namePlaceholder: 'Veuillez entrer votre nom',
            address: 'Adresse de l\'entreprise',
            addressPlaceholder: 'Veuillez entrer l\'adresse de votre entreprise',
            location: 'Ville / Pays',
            locationPlaceholder: 'Ex. : Paris, France',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Entrez votre WhatsApp pour vous contacter',
            email: 'E-mail',
            emailPlaceholder: 'Entrez votre e-mail pour vous contacter',
            remark: 'Remarques',
            remarkPlaceholder: 'Entrez vos remarques pour mieux vous comprendre',
            zipCode: 'Code Postal',
            zipCodePlaceholder: 'Entrez votre code postal'
        },
        alert: {
            fillRequired: 'Veuillez remplir tous les champs obligatoires (*)',
            submitSuccess: 'Demande soumise avec succès ! Notre équipe de vente vous contactera sous peu.',
            confirm: 'Confirmer',
            notice: 'Avis',
            success: 'Succès !',
            error: 'Erreur',
            invalidRequest: 'Requête invalide',
            rateLimit: 'Requêtes trop fréquentes. Veuillez réessayer dans {seconds} secondes.',
            invalidEmail: 'Veuillez saisir une adresse e-mail valide',
            invalidPhone: 'Veuillez saisir un numéro de téléphone valide',
            dangerousContent: 'La saisie contient des caractères non autorisés. Veuillez vérifier et réessayer.',
            cartEmpty: 'Aucun article valide dans le panier',
            securityCheck: 'Veuillez d\'abord effectuer la vérification de sécurité',
            submitFailed: 'Échec de la soumission, veuillez réessayer plus tard'
        }
    },
    contact: {
        hero: {
            title: 'Contactez-Nous',
            desc: 'Obtenez des conseils professionnels et les solutions les plus adaptées pour vous'
        },
        form: {
            title: 'Envoyez-nous un message',
            subtitle: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les 24 heures.',
            firstName: 'Prénom',
            firstNamePlaceholder: 'Ex. : Jean',
            lastName: 'Nom',
            lastNamePlaceholder: 'Ex. : Dupont',
            email: 'E-mail professionnel',
            emailPlaceholder: "jean{'@'}entreprise.com",
            inquiryType: 'Type de demande',
            selectTopic: 'Sélectionnez un sujet...',
            message: 'Message',
            messagePlaceholder: 'Comment pouvons-nous vous aider ?',
            fromProduct: 'Produit : {name}',
            submitBtn: 'Envoyer le message',
            sending: 'Envoi en cours...',
            successMsg: 'Merci ! Votre message a été envoyé avec succès.'
        },
        inquiry: {
            general: 'Question Générale',
            sales: 'Ventes & Distribution',
            support: 'Support Technique',
            hardware: 'OEM/ODM'
        },
        location: {
            title: 'Où Nous Sommes',
            officeName: 'Siège Social de Shenzhen',
            address: 'Bureau 603, Unité 1, Bâtiment 1, Place Kailifang, Rue Lianrun, Communauté Taoyuan, Quartier Dalang, District de Longhua, Shenzhen, Guangdong, Chine',
            phone: '+86 18926403313 Mme Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}